module.exports = __webpack_public_path__ + "img/discount.562f87.svg";